module.exports = __webpack_public_path__ + "img/logo_white.0df6b1dc.png";